/* Sop. Essential · Configurador Kit AM6 · modelos de tapa de piñón (requiere sop-kit.js; va antes de sop-kit-4.js)
 *
 * Lee los SVG tal cual salen de Inkscape (Contenido > Archivos):
 *   - capas "Color Base", "Color Detallles" y "Color Letras" → se pintan con los colores del cliente
 *   - la zona del número/logo dibujada en rojo (#ff0000), con cualquier forma y ángulo
 * Calcula el rectángulo y el ángulo de la zona, la quita y recorta el lienzo al dibujo.
 */
(function () {
  'use strict';
  var S = window.SopKit, Kit = S.Kit;
  var SVG_NS = 'http://www.w3.org/2000/svg';
  var SHAPES = 'path,rect,polygon,polyline,ellipse,circle';
  var VARS = { base: 'var(--c-base)', det: 'var(--c-details)', let: 'var(--c-letters)' };

  // Piñón genérico mientras no haya SVG del modelo
  var GENERIC_PINON = {
    viewBox: '0 0 120 140',
    inner: '<path d="M22 8h76c8 0 14 6 14 14v70c0 26-24 40-52 40S8 118 8 92V22C8 14 14 8 22 8z" fill="var(--c-base)" stroke="var(--c-details)" stroke-width="6"/>' +
      '<circle cx="22" cy="22" r="4" fill="var(--c-details)"/><circle cx="98" cy="22" r="4" fill="var(--c-details)"/>',
    slot: { cx: 60, cy: 73, w: 84, h: 54, angle: 0 }
  };

  function isRed(el) {
    return /#f00\b|#ff0000|fill\s*:\s*red\b|rgb\(\s*255\s*,\s*0\s*,\s*0\s*\)/i.test((el.getAttribute('style') || '') + ';fill:' + (el.getAttribute('fill') || ''));
  }
  // Capa a la que pertenece un elemento, por el nombre de capa de Inkscape
  function layerOf(el) {
    for (var g = el.parentNode; g && g.getAttribute; g = g.parentNode) {
      var lab = (g.getAttribute('inkscape:label') || '').toLowerCase();
      if (/zona/.test(lab)) return 'zone';
      if (/letra/.test(lab)) return 'let';
      if (/detal/.test(lab)) return 'det';
      if (/base/.test(lab)) return 'base';
    }
    return null;
  }

  // Rectángulo de área mínima que contiene los puntos → centro, lados y ángulo
  function minRect(pts) {
    var best = null;
    for (var a = 0; a < 180; a += 0.5) {
      var r = a * Math.PI / 180, c = Math.cos(r), s = Math.sin(r);
      var x0 = Infinity, x1 = -Infinity, y0 = Infinity, y1 = -Infinity;
      for (var i = 0; i < pts.length; i++) {
        var u = pts[i].x * c + pts[i].y * s, v = -pts[i].x * s + pts[i].y * c;
        if (u < x0) x0 = u; if (u > x1) x1 = u; if (v < y0) y0 = v; if (v > y1) y1 = v;
      }
      var area = (x1 - x0) * (y1 - y0);
      if (!best || area < best.area) best = { area: area, a: a, c: c, s: s, x0: x0, x1: x1, y0: y0, y1: y1 };
    }
    var w = best.x1 - best.x0, h = best.y1 - best.y0, ang = best.a;
    var uc = (best.x0 + best.x1) / 2, vc = (best.y0 + best.y1) / 2;
    if (h > w) { var t = w; w = h; h = t; ang += 90; }
    while (ang > 90) ang -= 180;
    while (ang <= -90) ang += 180;
    return { cx: uc * best.c - vc * best.s, cy: uc * best.s + vc * best.c, w: w, h: h, angle: Math.round(ang * 10) / 10 };
  }

  // Tapas: zona negra dentro del aro de detalles (S.TPL_FILES[k][2] = [cx, cy, radio])
  S.ringOf = function (p) {
    var T = S.TPL_FILES || {};
    for (var k in T) if (window[T[k][1]] === p) return T[k][2] || null;
    return null;
  };
  // Mayor escala k (<= kMax) y desplazamiento hacia el centro (hasta 25% del alto del hueco)
  // para que la caja de semiejes a*k x b*k no pase del aro.
  S.ringFit = function (slot, ring, a, b, kMax) {
    if (!ring) return { k: kMax, dx: 0, dy: 0 };
    var cx = slot.x + slot.w / 2, cy = slot.y + slot.h / 2, rx = ring[0], ry = ring[1];
    var m = /rotate\(\s*([-\d.]+)[\s,]+([-\d.]+)[\s,]+([-\d.]+)/.exec(slot.transform || '');
    if (m) { // centro del aro visto desde el sistema girado del hueco
      var t = -m[1] * Math.PI / 180, ox = +m[2], oy = +m[3], X = rx - ox, Y = ry - oy;
      rx = ox + X * Math.cos(t) - Y * Math.sin(t); ry = oy + X * Math.sin(t) + Y * Math.cos(t);
    }
    var R = ring[2] * 0.95, best = { k: 0, dx: 0, dy: 0 }, dist = Math.hypot(rx - cx, ry - cy) || 1;
    for (var i = 0; i <= 10; i++) {
      var f = Math.min(i / 10 * 0.25 * slot.h, dist), dx = (rx - cx) / dist * f, dy = (ry - cy) / dist * f;
      var ux = Math.abs(cx + dx - rx), uy = Math.abs(cy + dy - ry);
      var A = a * a + b * b, B = 2 * (ux * a + uy * b), C = ux * ux + uy * uy - R * R;
      var k = Math.min(C >= 0 ? 0 : (-B + Math.sqrt(B * B - 4 * A * C)) / (2 * A), kMax);
      if (k > best.k * 1.02) best = { k: k, dx: dx, dy: dy };
      if (k >= kMax) break;
    }
    if (best.k < kMax * 0.3) best.k = kMax * 0.3;
    return best;
  };

  // Regla de la tapa: el logo o texto solo puede ir sobre la base, nunca sobre detalles, letras ni agujeros.
  // Mapa de la tapa pintada con colores de marca (azul = base), con 1 px de margen.
  var MASKS = {}, MW = 480, tmpG = null;
  function svgMatrix(t) {
    tmpG = tmpG || document.createElementNS(SVG_NS, 'g');
    tmpG.setAttribute('transform', t || '');
    var c = tmpG.transform.baseVal.consolidate();
    return c ? DOMMatrix.fromMatrix(c.matrix) : new DOMMatrix();
  }
  S.baseMask = function (p, cb) {
    var body = p.rawSvg || (p.baseSvg || '') + (p.overlaySvg || ''), key = p.viewBox + '|' + body.length, m = MASKS[key];
    if (m) return typeof m === 'object' ? m : null;
    MASKS[key] = 'loading';
    var vb = p.viewBox.trim().split(/[\s,]+/).map(Number), sc = MW / vb[2], H = Math.round(vb[3] * sc), img = new Image();
    img.onload = function () {
      try {
        var c = document.createElement('canvas'); c.width = MW; c.height = H;
        var g = c.getContext('2d'); g.drawImage(img, 0, 0);
        var px = g.getImageData(0, 0, MW, H).data, n = MW * H, ok = new Uint8Array(n), ok2 = new Uint8Array(n), i;
        for (i = 0; i < n; i++) ok[i] = px[i * 4 + 3] > 230 && px[i * 4 + 2] > 200 && px[i * 4] < 60 && px[i * 4 + 1] < 60 ? 1 : 0;
        for (i = MW; i < n - MW; i++) ok2[i] = ok[i] & ok[i - 1] & ok[i + 1] & ok[i - MW] & ok[i + MW];
        MASKS[key] = { ok: ok2, w: MW, h: H, sc: sc, x0: vb[0], y0: vb[1] };
      } catch (e) { MASKS[key] = 'error'; }
      if (cb) cb();
    };
    img.onerror = function () { MASKS[key] = 'error'; };
    img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent('<svg xmlns="' + SVG_NS + '" viewBox="' + p.viewBox + '" width="' + MW + '" height="' + H +
      '" style="--c-base:#0000ff;--c-details:#ff0000;--c-letters:#00ff00">' + body + '</svg>');
    return null;
  };

  // Puntos pintados de una forma de w x h, relativos a su centro (en orden mezclado para descartar rápido)
  var PTS = {};
  function shapePoints(key, w, h, draw) {
    if (PTS[key]) return PTS[key];
    var R = 90 / Math.max(w, h), cw = Math.ceil(w * R) + 2, ch = Math.ceil(h * R) + 2, pts = [], x, y;
    var c = document.createElement('canvas'); c.width = cw; c.height = ch;
    var g = c.getContext('2d'); g.setTransform(R, 0, 0, R, 1, 1); draw(g);
    var px = g.getImageData(0, 0, cw, ch).data;
    for (y = 0; y < ch; y++) for (x = 0; x < cw; x++) if (px[(y * cw + x) * 4 + 3] > 40) pts.push([(x - 0.5) / R - w / 2, (y - 0.5) / R - h / 2]);
    for (x = pts.length - 1; x > 0; x--) { y = (x * 7919) % (x + 1); var t = pts[x]; pts[x] = pts[y]; pts[y] = t; }
    return (PTS[key] = pts);
  }
  S.logoPts = function (d) {
    return shapePoints('L' + d.bb.join() + d.off.length, d.bb[2], d.bb[3], function (g) {
      g.translate(-d.bb[0], -d.bb[1]);
      var m = svgMatrix(d.it); g.transform(m.a, m.b, m.c, m.d, m.e, m.f);
      g.fill(new Path2D(d.off)); if (d.lo) g.fill(new Path2D(d.lo));
    });
  };
  // Texto a 100 px (con su contorno), centrado
  S.textPts = function (text, width) {
    return shapePoints('T' + text, width + 10, 110, function (g) {
      g.font = '700 100px Archivo, sans-serif'; g.textAlign = 'center'; g.textBaseline = 'middle';
      g.lineWidth = 8; g.lineJoin = 'round';
      g.strokeText(text, (width + 10) / 2, 55); g.fillText(text, (width + 10) / 2, 55);
    });
  };

  // Mayor escala k (<= kMax) con un pequeño desplazamiento para que todos los puntos caigan sobre base.
  // sx estrecha en horizontal (textos comprimidos para caber). El tamaño puede pasar del hueco (x1.5): manda la base.
  S.baseFit = function (mask, slot, pts, sx, kMax) {
    kMax *= 1.5;
    var M = slot.transform ? svgMatrix(slot.transform) : null, cx = slot.x + slot.w / 2, cy = slot.y + slot.h / 2;
    var offs = [[0, 0]], dirs = [[0, 1], [0, -1], [1, 0], [-1, 0], [1, 1], [-1, 1], [1, -1], [-1, -1]], j, q;
    for (j = 1; j <= 3; j++) dirs.forEach(function (v) { offs.push([v[0] * j * slot.w * 0.06, v[1] * j * slot.h * 0.12]); });
    function fits(k, dx, dy) {
      for (var i = 0; i < pts.length; i++) {
        var x = cx + dx + pts[i][0] * k * sx, y = cy + dy + pts[i][1] * k;
        if (M) { var X = M.a * x + M.c * y + M.e; y = M.b * x + M.d * y + M.f; x = X; }
        var mx = Math.floor((x - mask.x0) * mask.sc), my = Math.floor((y - mask.y0) * mask.sc);
        if (mx < 0 || my < 0 || mx >= mask.w || my >= mask.h || !mask.ok[my * mask.w + mx]) return false;
      }
      return true;
    }
    for (var k = kMax; k >= kMax * 0.12; k *= 0.95) {
      for (q = 0; q < offs.length; q++) if (fits(k, offs[q][0], offs[q][1])) return { k: k, dx: offs[q][0], dy: offs[q][1] };
    }
    return { k: kMax * 0.12, dx: 0, dy: 0 };
  };

  // Kit montado igual para todos los modelos: cada dibujo se recorta a su silueta real.
  // Tapa de 1000 de alto con el borde derecho en 880; piñón de 710 de alto, 75 más abajo, metido un 24 % de su ancho.
  var KIT = { th: 1000, tr: 880, ph: 710, py: 75, ov: 0.24 };
  function contentBox(markup, viewBox) {
    var host = document.createElement('div');
    host.style.cssText = 'position:absolute;left:-9999px;top:0;width:600px;height:600px;visibility:hidden;pointer-events:none';
    host.innerHTML = '<svg xmlns="' + SVG_NS + '" viewBox="' + viewBox + '" width="600" height="600">' + markup + '</svg>';
    document.body.appendChild(host);
    try { var b = host.firstChild.getBBox(); return b.width && b.height ? [b.x, b.y, b.width, b.height] : null; }
    catch (e) { return null; } finally { host.parentNode.removeChild(host); }
  }
  S.kitLayout = function (p, model) {
    if (!p.skBox) p.skBox = contentBox(p.rawSvg || (p.baseSvg || '') + (p.overlaySvg || ''), p.viewBox) || p.viewBox.trim().split(/[\s,]+/).map(Number);
    var bb = p.skBox, tw = KIT.th * bb[2] / bb[3], t = { x: KIT.tr - tw, y: 0, w: tw, h: KIT.th, vb: bb.join(' ') }, pb = null, right = KIT.tr;
    if (model) {
      var pv = model.viewBox.trim().split(/[\s,]+/).map(Number), pw = KIT.ph * pv[2] / pv[3];
      pb = { x: KIT.tr - pw * KIT.ov, y: KIT.py, w: pw, h: KIT.ph, vb: model.viewBox };
      right = pb.x + pw;
    }
    var x0 = Math.min(0, t.x);
    return { vb: x0 + ' 0 ' + (right - x0) + ' ' + KIT.th, t: t, p: pb };
  };

  function prepare(txt) {
    var svg = new DOMParser().parseFromString(txt, 'image/svg+xml').querySelector('svg');
    if (!svg) throw new Error('svg');
    Array.prototype.slice.call(svg.querySelectorAll('*')).forEach(function (e) {
      if (e.namespaceURI !== SVG_NS || /^(metadata|title|desc)$/i.test(e.localName)) e.parentNode.removeChild(e);
    });
    var shapes = Array.prototype.slice.call(svg.querySelectorAll(SHAPES));
    var zone = shapes.filter(isRed)[0] || shapes.filter(function (e) { return layerOf(e) === 'zone'; })[0];
    if (zone) zone.setAttribute('data-sk-zone', '1');
    shapes.forEach(function (el) {
      var k = layerOf(el);
      if (el === zone || !VARS[k]) return;
      var st = (el.getAttribute('style') || '').replace(/(^|;)\s*fill\s*:[^;]*/g, '');
      el.setAttribute('style', st + ';fill:' + VARS[k]);
      el.removeAttribute('fill');
    });

    // Para medir hace falta pintarlo: copia invisible fuera de pantalla
    var host = document.createElement('div');
    host.style.cssText = 'position:absolute;left:-9999px;top:0;width:600px;height:600px;visibility:hidden;pointer-events:none';
    var live = document.importNode(svg, true);
    live.setAttribute('width', '600');
    live.setAttribute('height', '600');
    host.appendChild(live);
    document.body.appendChild(host);
    var slot = null, z = live.querySelector('[data-sk-zone]');
    try {
      if (z) {
        var m = live.getScreenCTM().inverse().multiply(z.getScreenCTM()), pts = [], p, i;
        if (z.getTotalLength) {
          var L = z.getTotalLength();
          for (i = 0; i <= 240; i++) { p = z.getPointAtLength(L * i / 240); pts.push({ x: m.a * p.x + m.c * p.y + m.e, y: m.b * p.x + m.d * p.y + m.f }); }
        } else {
          var b = z.getBBox();
          [[b.x, b.y], [b.x + b.width, b.y], [b.x, b.y + b.height], [b.x + b.width, b.y + b.height]].forEach(function (q) {
            pts.push({ x: m.a * q[0] + m.c * q[1] + m.e, y: m.b * q[0] + m.d * q[1] + m.f });
          });
        }
        slot = minRect(pts);
        z.parentNode.removeChild(z);
      }
      var bb = live.getBBox(), pad = Math.max(bb.width, bb.height) * 0.02;
      var vb = [bb.x - pad, bb.y - pad, bb.width + pad * 2, bb.height + pad * 2].map(function (n) { return Math.round(n * 100) / 100; }).join(' ');
    } finally {
      host.parentNode.removeChild(host);
    }
    if (zone) zone.parentNode.removeChild(zone);
    var inner = svg.innerHTML;
    return { viewBox: vb, inner: inner, slot: slot || GENERIC_PINON.slot };
  }

  Kit.prototype.pinonModel = function (i, cb) {
    var p = this.data.pinones[i], self = this;
    if (!p || !p.svg) return GENERIC_PINON;
    var c = this.pcache[i];
    if (c === 'error') return GENERIC_PINON;
    if (c && c !== 'loading') return c;
    if (!c) {
      this.pcache[i] = 'loading';
      fetch(p.svg).then(function (r) { return r.text(); }).then(function (txt) {
        self.pcache[i] = prepare(txt);
      }).catch(function () { self.pcache[i] = 'error'; }).then(function () { if (cb) cb(); });
    }
    return GENERIC_PINON;
  };

  // Piñón del modelo i con su número, texto o logo dentro de la zona.
  // Con "horizontal" activado en el bloque (p. ej. V4) el número y el logo van rectos y el texto sigue el ángulo de la zona.
  Kit.prototype.pinonSvg = function (i, entry, cb) {
    var model = this.pinonModel(i, cb), upright = (this.data.pinones[i] || {}).upright;
    var val = entry ? { type: entry.logo ? 'logo' : 'text', value: entry.logo || entry.show } : null;
    var s = model.slot, box;
    if (upright && entry && entry.kind !== 'Texto' && s.angle) {
      var r = s.angle * Math.PI / 180, side = Math.min(s.w, s.h) / (Math.abs(Math.cos(r)) + Math.abs(Math.sin(r)));
      box = { x: s.cx - side / 2, y: s.cy - side / 2, w: side, h: side };
    } else {
      box = { x: s.cx - s.w / 2, y: s.cy - s.h / 2, w: s.w, h: s.h };
      if (s.angle) box.transform = 'rotate(' + s.angle + ' ' + s.cx + ' ' + s.cy + ')';
    }
    return '<svg viewBox="' + model.viewBox + '" role="img" aria-label="Tapa de piñón">' + model.inner + this.slotSvg(box, val) + '</svg>';
  };
})();